export function toLocaleString(x: any) {
  return (typeof x === 'number' || typeof x === 'string') ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : x;
}
